import React, { Component } from 'react';
import Modal from '../../../components/modals';

import { gql } from '@apollo/client';
import _ from 'lodash';
import { toast } from 'react-toastify';

import InputHeader from '../../global/inputwithHeader';
import { ReactComponent as MoreVerticalIcon } from '../../../../assets/svg/Project/more-vertical.svg';
import { ReactComponent as DeleteIcon } from '../../../../assets/svg/trash3.svg';
import LoadingBar from '../../../components/global/loadingBar';

import moment from 'moment';
import { withRouter } from '../../../../services/withRoute';
import TenantUsersController from '../../../../controllers/tenantUsers';
import jwt_decode from 'jwt-decode';
import Select from 'react-select';
import constants from '../../../../utils/constants';

var validator = require('validator');
const createUser = gql`
	mutation RootMutation($userInput: CreateTenantUserInput!, $branchId: String!) {
		createTenantUser(userInput: $userInput, branchId: $branchId) {
			id
		}
	}
`;
const edituser = gql`
	mutation UpdateTenantUser($userId: ID!, $userInput: UpdateTenantUserInput, $branchId: String) {
		updateTenantUser(userId: $userId, userInput: $userInput, branchId: $branchId) {
			id
			firstName
			lastName
			email
			phoneNumber
			isEmailVerified
			displayName
			isShooter
			isFreelancer
			isSuspended
			accessibleTenants {
				tenant_id
				workspaceId
				role
				walletBalance
			}
			accessibleBranches {
				_id
				branchId
			}
			skillLevel {
				candidPhotography
				candidCinematography
				traditionalPhotography
				traditionalVideography
				leadership
			}
		}
	}
`;

const updateWorkspaceAccess = gql`
	mutation UpdateTenantAccess($userId: ID!, $accessInput: UpdateTenantAccessInput!) {
		updateTenantAccess(userId: $userId, accessInput: $accessInput) {
			message
		}
	}
`;

const suspendTenantUser = gql`
	mutation UpdateTenantUserSuspension($userId: ID!, $isSuspended: Boolean) {
		updateTenantUserSuspension(userId: $userId, isSuspended: $isSuspended) {
			id
			firstName
			lastName
			email
			phoneNumber
			isEmailVerified
			displayName
			isShooter
			isFreelancer
			isSuspended
			skillLevel {
				candidPhotography
				candidCinematography
				traditionalPhotography
				traditionalVideography
				leadership
			}
			accessibleTenants {
				tenant_id
				workspaceId
				role
				walletBalance
			}
			accessibleBranches {
				_id
				branchId
			}
		}
	}
`;

class TenantUserDetails extends TenantUsersController {
	constructor(props) {
		super(props);
		this.state = {
			firstName: '',
			firstNameError: false,
			firstNameErrorMessage: '',
			lastName: '',
			lastNameError: false,
			lastNameErrorMessage: '',
			phoneNumber: '+91',
			phoneNumberError: false,
			phoneNumberErrorMessage: '',
			email: '',
			emailError: false,
			emailErrorMessage: '',
			displayName: '',
			displayNameError: false,
			displayNameErrorMessage: '',
			isShooter: true,
			accessibleWorkspaces: [],
			tenantUserDetails: null,
			userModalType: props.userModalType,
			isFileSrcLoading: true,
			isFreelancer: false,
			isSuspended: false,
			branchId: null,
			skillLevelArray: [
				{
					name: 'Leadership',
					value: 'leadership',
				},
				{
					name: 'Candid Photo',
					value: 'candidPhotography',
					marginTop: '20px',
				},
				{
					name: 'Traditional Photo',
					value: 'traditionalPhotography',
				},
				{
					name: 'Candid Video',
					value: 'candidCinematography',
					marginTop: '20px',
				},
				{
					name: 'Traditional Video',
					value: 'traditionalVideography',
				},
			],
			skillLevel: {
				candidPhotography: 0,
				candidCinematography: 0,
				traditionalPhotography: 0,
				traditionalVideography: 0,
				leadership: 0,
			},
			adminUserIDs: ['626d3751c5c41818a3994c97', '6128dd2f4253cefe5154c52b'],
			branchesList: [],
		};
	}
	componentDidMount = async () => {
		if (this.props.userModalType === 'add') {
			this.setState({
				isFileSrcLoading: false,
			});
		}
		if (this.state.userModalType !== 'add' && this.props.tenantUserDetails !== null) {
			let accessibleWorkspaces = [];
			_.map(this.props.tenantUserDetails.accessibleTenants, (tenant, key) => {
				accessibleWorkspaces.push(tenant['workspaceId']);
			});
			const initialSkillLevel =
				_.has(this.props.tenantUserDetails, 'skillLevel') &&
				this.props.tenantUserDetails.skillLevel != null
					? this.props.tenantUserDetails.skillLevel
					: this.state.skillLevel;
			this._originalValues = {
				firstName: this.props.tenantUserDetails.firstName,
				lastName: this.props.tenantUserDetails.lastName,
				displayName: this.props.tenantUserDetails.displayName,
				phoneNumber: this.props.tenantUserDetails.phoneNumber,
				isShooter: this.props.tenantUserDetails.isShooter,
				isFreelancer: _.has(this.props.tenantUserDetails, 'isFreelancer')
					? this.props.tenantUserDetails.isFreelancer
					: false,
				skillLevel: { ...initialSkillLevel },
			};
			this.setState({
				firstName: this.props.tenantUserDetails.firstName,
				lastName: this.props.tenantUserDetails.lastName,
				email: this.props.tenantUserDetails.email,
				phoneNumber: this.props.tenantUserDetails.phoneNumber,
				displayName: this.props.tenantUserDetails.displayName,
				isShooter: this.props.tenantUserDetails.isShooter,
				isFreelancer: _.has(this.props.tenantUserDetails, 'isFreelancer')
					? this.props.tenantUserDetails.isFreelancer
					: false,
				isSuspended: _.has(this.props.tenantUserDetails, 'isSuspended')
					? this.props.tenantUserDetails.isSuspended
					: false,
				accessibleTenants: this.props.tenantUserDetails.accessibleTenants,
				accessibleWorkspaces,
				isFileSrcLoading: false,
				skillLevel: initialSkillLevel,
				branchId:
					_.has(this.props.tenantUserDetails, 'accessibleBranches') &&
					this.props.tenantUserDetails.accessibleBranches != null
						? this.props.tenantUserDetails.accessibleBranches[0]['branchId']
						: null,
			});
		}

		let usertoken = localStorage.getItem('usertoken');
		let decoded = await jwt_decode(usertoken);

		const vendorId = this.props.params.vendorID;
		const global = constants.userAccess.global || {};
		const vendor = constants.userAccess.vendors?.[vendorId] || {};
		const adminUserIDs = [...new Set([...(global.adminUserIDs || []), ...(vendor.adminUserIDs || [])])];
		const crewPlannerUserIds = [...new Set([...(global.crewPlannerUserIds || []), ...(vendor.crewPlannerUserIds || [])])];
		const canEditSkills = adminUserIDs.includes(decoded.user_id) || crewPlannerUserIds.includes(decoded.user_id);

		this.setState({
			userName: decoded.userName,
			userId: decoded.user_id,
			canEditSkills,
		});

		// document.addEventListener('mousedown', this.handleClickOutside)
	};
	componentWillUnmount() {
		// document.removeEventListener('mousedown', this.handleClickOutside)
	}

	handleClickOutside = (event) => {
		if (this.dropdownref.current && !this.dropdownref.current.contains(event.target)) {
			this.setState({
				showDropDown: false,
			});
		}
	};
	handleCloseModal = () => {
		this.props.close();
	};
	handleOnChange = (e, name) => {
		this.setState({
			[name]: e.target.value,
			[`${name}Error`]: false,
			[`${name}ErrorMessage`]: '',
		});

		let inputError = name + 'Error';
		let inputErrorMessage = name + 'ErrorMessage';

		if (name === 'phoneNumber') {
			var isPhoneNumberValid = validator.isMobilePhone(e.target.value.trim(), 'any', {
				strictMode: true,
			});
			if (
				this.state[`${name}`].split('/').at(-1).length > 0 &&
				e.target.value.split('/').at(-1).length === 0
			) {
				this.setState({
					[inputError]: true,
					[inputErrorMessage]: 'This field cannot be empty',
				});
			} else if (!isPhoneNumberValid) {
				this.setState({
					[inputError]: true,
					[inputErrorMessage]: 'Invalid Phone Number! Example Format: +919999999999',
				});
			} else {
				this.setState({
					[inputError]: false,
					[inputErrorMessage]: '',
				});
			}
		} else if (name === 'email') {
			var isEmailValid = validator.isEmail(e.target.value.trim());
			if (
				this.state[`${name}`].split('/').at(-1).length > 0 &&
				e.target.value.split('/').at(-1).length === 0
			) {
				this.setState({
					[inputError]: true,
					[inputErrorMessage]: 'This field cannot be empty',
				});
			} else if (!isEmailValid) {
				this.setState({
					[inputError]: true,
					[inputErrorMessage]: 'Invalid email! Example Format: username@gmail.com',
				});
			} else {
				this.setState({
					[inputError]: false,
					[inputErrorMessage]: '',
				});
			}
		} else {
			if (name === 'firstName' || name === 'lastName' || name === 'displayName') {
				if (e.target.value === '') {
					this.setState({
						[inputError]: true,
						[inputErrorMessage]: 'This field cannot be empty',
					});
				}
			}
		}
	};
	isDisabled = () => {
		if (
			this.state.email === '' ||
			(this.state.phoneNumber != null &&
				!validator.isMobilePhone(this.state.phoneNumber.trim(), 'any', {
					strictMode: true,
				})) ||
			this.state.phoneNumber === '' ||
			(this.state.email != null && !validator.isEmail(this.state.email.trim())) ||
			this.state.firstName === '' ||
			this.state.displayName === '' ||
			_.size(this.state.accessibleWorkspaces) < 1 ||
			(this.props.userModalType === 'add' && this.state.branchId === null)
		) {
			return true;
		} else {
			return false;
		}
	};
	hasChanges = () => {
		if (!this._originalValues) return false;
		const o = this._originalValues;
		if (this.state.firstName !== o.firstName) return true;
		if (this.state.lastName !== o.lastName) return true;
		if (this.state.displayName !== o.displayName) return true;
		if (this.state.phoneNumber !== o.phoneNumber) return true;
		if (this.state.isShooter !== o.isShooter) return true;
		if (this.state.isFreelancer !== o.isFreelancer) return true;
		if (this.state.canEditSkills && o.skillLevel) {
			const keys = ['candidPhotography', 'candidCinematography', 'traditionalPhotography', 'traditionalVideography', 'leadership'];
			for (const k of keys) {
				if ((this.state.skillLevel[k] || 0) !== (o.skillLevel[k] || 0)) return true;
			}
		}
		return false;
	};
	handleAddmember = async (e) => {
		let json = {
			userInput: {
				accessibleWorkspaces: this.state.accessibleWorkspaces,
				displayName: this.state.displayName,
				email: this.state.email,
				firstName: this.state.firstName,
				isShooter: this.state.isShooter,
				lastName: this.state.lastName,
				phoneNumber: this.state.phoneNumber,
			},
			branchId: this.state.branchId,
		};
		await this.addTenantMember(createUser, json, true);
	};
	handleEditmember = async (e) => {
		let userInput = {
			displayName: this.state.displayName,
			firstName: this.state.firstName,
			isShooter: this.state.isShooter == null ? false : this.state.isShooter,
			lastName: this.state.lastName,
			phoneNumber: this.state.phoneNumber,
		};
		// Only send skillLevel if user has permission to edit it
		if (this.state.canEditSkills) {
			const skillLevel = { ...this.state.skillLevel };
			delete skillLevel['__typename'];
			userInput.skillLevel = skillLevel;
		}
		let json = {
			userId: this.props.activeUserID,
			branchId: this.state.branchId,
			userInput,
		};
		await this.addTenantMember(edituser, json);
	};
	handleWorkspace = (e, workspace) => {
		let accessibleWorkspaces = this.state.accessibleWorkspaces;

		if (e.target.checked == true) {
			accessibleWorkspaces.push(workspace);
			if (this.props.userModalType !== 'add') {
				let json = {
					userId: this.props.activeUserID,
					accessInput: {
						addWorkspaceAccess: workspace,
					},
				};
				this.updateMemberWorkspaceAccess(updateWorkspaceAccess, json, 'add');
			}
		} else {
			const index = accessibleWorkspaces.indexOf(workspace);
			if (index > -1) {
				accessibleWorkspaces.splice(index, 1);
			}
			if (this.props.userModalType !== 'add') {
				let json = {
					userId: this.props.activeUserID,
					accessInput: {
						removeWorkspaceAccess: workspace,
					},
				};
				this.updateMemberWorkspaceAccess(updateWorkspaceAccess, json, 'remove');
			}
		}

		this.setState({ accessibleWorkspaces });
	};

	updateShooterPreferences = async (shooterType) => {
		this.setState(
			{
				[shooterType]: !this.state[shooterType],
			},
			async () => {
				if (this.props.userModalType !== 'add') {
					let json = {
						userId: this.props.activeUserID,
						branchId: this.state.branchId,
						userInput: {
							displayName: this.state.displayName,
							firstName: this.state.firstName,
							isShooter: this.state.isShooter == null ? false : this.state.isShooter,
							isFreelancer:
								this.state.isFreelancer == null ? false : this.state.isFreelancer,
							lastName: this.state.lastName,
							phoneNumber: this.state.phoneNumber,
						},
					};
					await this.addTenantMember(edituser, json);
				}
			},
		);
	};

	suspendTenantUser = async (shooterType) => {
		this.setState(
			{
				[shooterType]: !this.state[shooterType],
			},
			async () => {
				let json = {
					userId: this.props.activeUserID,
					isSuspended: this.state.isSuspended,
				};
				this.setState({
					showDropDown: !this.state.showDropDown,
				});
				await this.addTenantMember(
					suspendTenantUser,
					json,
					null,
					this.state.isSuspended ? 'Member suspended successfully!' : 'Member unsuspended successfully!',
				);
			},
		);
	};

	onClickSkillLevel = (skillKey, value) => {
		let skillLevel = this.state.skillLevel;
		skillLevel[skillKey] = value;

		this.setState({
			skillLevel,
		});
	};

	toggleDropDown = (e) => {
		this.setState({
			showDropDown: !this.state.showDropDown,
		});
	};

	renderSkillSetContainer = () => {
		return (
			<div className="mc-record-body-left-right right-user-modal" style={{ width: '30%' }}>
				<div className="left-item-container user-modal-title " style={{ height: '20px' }}>
					SKILL LEVEL
				</div>
				<div className="workspaces">
					{_.map(this.state.skillLevelArray, (skillLevel, key) => {
						return (
							<div
								className="workspace-item"
								style={{
									width: '100%',
									flexDirection: 'column',
									alignItems: 'flex-start',
									marginTop: _.has(skillLevel, 'marginTop')
										? skillLevel.marginTop
										: '',
								}}
							>
								<div
									className="skill-level-name"
									style={{
										width: '100%',
										color: this.state.isShooter ? '' : '#707070',
									}}
								>
									{skillLevel.name}
								</div>
								<div className="skillLevelContainer" style={{ marginTop: '10px' }}>
									<div
										className={`skillLevel  ${
											this.state.skillLevel[skillLevel.value] <= 1
												? ''
												: 'active'
										}
										${this.state.isSuspended ? 'disabled' : ''}
										`}
										onClick={() =>
											this.state.isSuspended
												? ''
												: this.onClickSkillLevel(skillLevel.value, 0)
										}
									>
										0
									</div>
									{_.map(Array(10), (key, index) => {
										return (
											<div
												className={`skillLevel  ${
													this.state.skillLevel[skillLevel.value] <
													index + 1
														? ''
														: 'active'
												}
										${this.state.isSuspended ? 'disabled' : ''}
										`}
												onClick={() =>
													this.state.isSuspended
														? ''
														: this.onClickSkillLevel(
																skillLevel.value,
																index + 1,
														  )
												}
											>
												{index + 1}
											</div>
										);
									})}
								</div>
							</div>
						);
					})}
				</div>
			</div>
		);
	};

	renderWorkspaceListContainer = () => {
		return (
			<>
				<div className="left-item-container user-modal-title" style={{ height: '20px' }}>
					WORKSPACE ACCESS
				</div>
				<div className="workspaces">
					{_.map(this.props.vendorTenants, (tenant, key) => {
						return (
							<div className="workspace-item">
								<label class="checkbox-container">
									<input
										type="checkbox"
										disabled={
											this.state.isSuspended
												? true
												: this.props.userModalType !== 'add'
												? this.state.isShooter
													? _.size(
															_.filter(this.state.accessibleTenants, {
																workspaceId: tenant.workspaceId,
															}),
													  ) > 0 &&
													  _.filter(this.state.accessibleTenants, {
															workspaceId: tenant.workspaceId,
													  })[0].role === 'admin'
														? true
														: false
													: true
												: false
										}
										onChange={(e) =>
											this.props.userModalType !== 'add'
												? _.size(
														_.filter(this.state.accessibleTenants, {
															workspaceId: tenant.workspaceId,
														}),
												  ) > 0 &&
												  _.filter(this.state.accessibleTenants, {
														workspaceId: tenant.workspaceId,
												  })[0].role === 'admin'
													? ''
													: this.handleWorkspace(e, tenant.workspaceId)
												: this.handleWorkspace(e, tenant.workspaceId)
										}
										checked={this.state.accessibleWorkspaces.includes(
											tenant.workspaceId,
										)}
									/>
									<span class="checkmark"></span>
								</label>
								<span
									className="name"
									style={{
										color: this.state.isShooter ? '' : '#707070',
									}}
								>
									{tenant.workspaceId}
								</span>
							</div>
						);
					})}
				</div>
			</>
		);
	};

	handleBranchChange = (e) => {
		this.setState({
			branchId: e.value,
		});
	};

	render() {
		return (
			<Modal
				handleClose={() => this.handleCloseModal()}
				show={this.props.show}
				modalType={'center'}
			>
				<div className="mc-record-center-modal">
					<div className="mc-record-header">
						<span className="header-title">
							{this.props.userModalType === 'add' ? 'Add' : 'Edit'} Member
						</span>
						{this.props.userModalType !== 'add' ? (
							<span
								className="header-more-icn"
								onClick={(e) => this.toggleDropDown(e)}
							>
								<MoreVerticalIcon />
							</span>
						) : (
							''
						)}

						{this.state.showDropDown === true ? (
							<div className="delete-action-dropdown">
								<div
									className="delete-action-item"
									ref={this.dropdownref}
									onClick={(e) => this.suspendTenantUser('isSuspended')}
								>
									{this.state.isSuspended ? (
										<>
											<span className="delete-icn"></span>
											<span className="delete-text activate">
												Unsuspend member
											</span>
										</>
									) : (
										<>
											<span className="delete-icn">
												<DeleteIcon />
											</span>
											<span className="delete-text">Suspend User</span>
										</>
									)}
								</div>
							</div>
						) : null}
					</div>
					{this.state.isFileSrcLoading ? (
						<LoadingBar />
					) : (
						<>
							<div className="mc-record-body">
								<div
									className="mc-record-body-left-right create-user-left"
									style={{ width: '30%' }}
								>
									<div className="left-item-container user-modal-title">
										USER DETAILS
									</div>
									<div className="left-item-container">
										<InputHeader
											type="text"
											name="firstName"
											isInputError={this.state.firstNameError}
											label="First Name"
											value={this.state.firstName}
											onChange={(e) => this.handleOnChange(e, 'firstName')}
											errorMessage={this.state.firstNameErrorMessage}
											width="100%"
											marginBottom="0px"
											required={true}
											readOnly={this.state.isSuspended}
										/>
									</div>
									<div className="left-item-container">
										<InputHeader
											type="text"
											name="lastName"
											isInputError={false}
											label="Last Name"
											value={this.state.lastName}
											onChange={(e) => this.handleOnChange(e, 'lastName')}
											errorMessage={''}
											width="100%"
											marginBottom="0px"
											required={false}
											readOnly={this.state.isSuspended}
										/>
									</div>

									<div className="left-item-container">
										<InputHeader
											type="text"
											name="email"
											isInputError={this.state.emailError}
											label="Email"
											value={this.state.email}
											onChange={(e) => this.handleOnChange(e, 'email')}
											errorMessage={this.state.emailErrorMessage}
											width="100%"
											marginBottom="0px"
											required={true}
											readOnly={
												this.state.userModalType === 'add' ? false : true
											}
										/>
									</div>

									<div className="left-item-container">
										<InputHeader
											type="text"
											name="phoneNumber"
											isInputError={this.state.phoneNumberError}
											label="Phone Number"
											value={this.state.phoneNumber}
											onChange={(e) => this.handleOnChange(e, 'phoneNumber')}
											errorMessage={this.state.phoneNumberErrorMessage}
											width="100%"
											marginBottom="0px"
											required={true}
											readOnly={this.state.isSuspended}
										/>
									</div>
									<div className="left-item-container">
										<InputHeader
											type="text"
											name="displayName"
											isInputError={this.state.displayNameError}
											label="Display Name"
											value={this.state.displayName}
											onChange={(e) => this.handleOnChange(e, 'displayName')}
											errorMessage={this.state.displayNameErrorMessage}
											width="100%"
											marginBottom="0px"
											required={true}
											readOnly={this.state.isSuspended}
										/>
									</div>
								</div>
								<div
									className="mc-record-body-left-right right-user-modal"
									style={{ width: '30%' }}
								>
									<div className="left-item-container user-modal-title">
										USER DETAILS
									</div>
									<div className="floating-select-container">
										<label>
											Branch
											<span className="required-star">*</span>
										</label>
										<Select
											key={_.size(this.props.branchesListOption)}
											className={
												'cost-select-container zIndex5 w-100p' +
												(this.state.isSuspended
													? ' cost-select--is-disabled'
													: '')
											}
											classNamePrefix="cost-select"
											options={this.props.branchesListOption}
											onChange={(e) => this.handleBranchChange(e)}
											defaultValue={_.find(this.props.branchesListOption, {
												value: this.state.branchId,
											})}
											isDisabled={this.state.isSuspended}
											isSearchable={true}
										/>
									</div>
									<div
										style={{
											width: '100%',
											marginBottom: '20px',
										}}
									>
										<div
											className=" is-shooter"
											style={{
												width: '50%',
												float: 'left',
											}}
										>
											Shooter
											<label
												className="switch"
												style={{ marginLeft: '10px' }}
											>
												<input
													type="checkbox"
													checked={this.state.isShooter}
													onChange={(e) =>
														this.updateShooterPreferences('isShooter')
													}
													disabled={this.state.isSuspended}
												/>
												<span className="slider round"></span>
											</label>
										</div>
										<div className=" is-shooter">
											Freelancer
											<label
												className="switch"
												style={{ marginLeft: '10px' }}
											>
												<input
													type="checkbox"
													checked={this.state.isFreelancer}
													onChange={(e) =>
														this.updateShooterPreferences(
															'isFreelancer',
														)
													}
													disabled={this.state.isSuspended}
												/>
												<span className="slider round"></span>
											</label>
										</div>
									</div>
									{this.state.isShooter
										? this.renderWorkspaceListContainer()
										: ''}
								</div>
								{this.state.canEditSkills && this.renderSkillSetContainer()}

								<div className="mc-record-footer">
									<a className="cancel" onClick={(e) => this.handleCloseModal()}>
										Cancel
									</a>
									<a
										className={`add-btn ${this.isDisabled() || (this.props.userModalType !== 'add' && !this.hasChanges()) ? 'disabled' : ''}`}
										onClick={(e) =>
											this.isDisabled() || (this.props.userModalType !== 'add' && !this.hasChanges())
												? ''
												: this.props.userModalType === 'add'
												? this.handleAddmember(e)
												: this.handleEditmember(e)
										}
									>
										{this.props.userModalType === 'add' ? 'Add' : this.hasChanges() ? 'Update' : 'Edit'} Member
									</a>
								</div>
							</div>
						</>
					)}
				</div>
			</Modal>
		);
	}
}

export default withRouter(TenantUserDetails);
